<div class="avatar__wrapper" [title]="'Заходил(а) ' + (user?.activityAt | date: 'yyyy-MM-dd HH:mm')">
  @if (image()) {
    <span class="avatar__image" [style.backgroundImage]="'url(' + image() + ')'"> </span>
  }

  @if (shortUserName()) {
    <span class="avatar__text">{{ shortUserName() }}</span>
  } @else {
    <span class="avatar__text"><i class="icon-man"></i></span>
  }

  @if (isOnline()) {
    <span class="avatar__online"></span>
  }

  @if (showDeleteBtn) {
    <span class="avatar__delete" (click)="onRemoveClick()">
      <i class="icon-close"></i>
    </span>
  }
</div>
